import { render, staticRenderFns } from "./privacy-xnj.vue?vue&type=template&id=02c084c4&"
import script from "./privacy-xnj.vue?vue&type=script&lang=js&"
export * from "./privacy-xnj.vue?vue&type=script&lang=js&"
import style0 from "./privacy-xnj.vue?vue&type=style&index=0&id=02c084c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports